exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3eQbS0Zn_3j-9Xm9wBsK1P {\n  white-space: nowrap; }\n\n._2B9-HeFA7C4xARoMI9cCKn {\n  display: inline-block;\n  padding: 0 .1em; }\n", ""]);

// exports
exports.locals = {
	"container": "_3eQbS0Zn_3j-9Xm9wBsK1P",
	"seperator": "_2B9-HeFA7C4xARoMI9cCKn"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/TimeDisplay/styles.scss
// module id = 56
// module chunks = 0